import React, { useState } from 'react';
import { IonIcon, IonInput, IonButton, IonLabel } from '@ionic/react';
import { eye, eyeOff } from 'ionicons/icons';
import './index.css';

const PasswordInput = ({ value: propValue, label, labelColor, onIonChange, ...rest }) => {
  const [value, setValue] = useState(propValue || '');
  const [show, setShow] = useState(false);

  const togglePass = (show) => {
    setShow(show);
  };

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onIonChange) {
      onIonChange(e);
    }
  };

  return (
    <div className="okx-password-wrapper">
      <div className="okx-password-holder">
        {label && (
          <IonLabel position="floating" color={labelColor}>
            {label}
          </IonLabel>
        )}
        <IonInput
          {...rest}
          className="okx-password"
          type={show ? 'text' : 'password'}
          pattern="password"
          value={value}
          onIonInput={handleChange}
          onIonBlur={handleChange}
        />
      </div>
      <IonButton
        disabled={value === ''}
        fill="clear"
        size="small"
        onTouchStart={() => togglePass(true)}
        onTouchEnd={() => togglePass(false)}
        onMouseDown={() => togglePass(true)}
        onMouseUp={() => togglePass(false)}
      >
        <IonIcon slot="icon-only" icon={show ? eye : eyeOff} />
      </IonButton>
    </div>
  );
};

export default PasswordInput;
